export const exportTableToCsv = (id = 'csv-planning-obj', fileName = 'file') => {
    const table = document.getElementById(id) as HTMLTableElement;
    if (!table) return;

    const rows = Array.from(table.querySelectorAll('tr'));
    if (!rows) return;

    const csvData: string[] = [];

    rows.forEach((row) => {
        if (row.style.display === 'none') return;
        if (row.getAttribute('data-export') === 'false') return;

        const cols = Array.from(row.querySelectorAll('th, td'))
            .map((col) => {
                const colClone = col.cloneNode(true) as HTMLElement;

                const elementsToRemove = colClone.querySelectorAll('.no-export');
                elementsToRemove.forEach((el) => el.remove());

                // Get text after cleaning
                let textContent = colClone.textContent?.trim() || '';
                let title = '';
                let value = '';

                const children = Array.from(colClone.querySelectorAll('*'));
                children.forEach((child) => {
                    if (!textContent && child.textContent?.trim()) {
                        textContent = child.textContent.trim();
                    }
                    
                    if (child.getAttribute('value')) {
                        value = child.getAttribute('value')?.trim() || '';
                    }
                });

                return (value || textContent || title || '').replaceAll('\n', '    |||    ');
            })
            .join(';');
        csvData.push(cols);
    });

    const csvString = '\uFEFF' + csvData.join('\n');

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `mysltp-${fileName}.csv`;
    a.click();

    URL.revokeObjectURL(url);
};
